module.exports = __webpack_public_path__ + "img/film-threat-before-home.42c9f3ce.jpg";